import ContentBlockWithImage from './ContentBlockWithImage';

export default ContentBlockWithImage;
